import { createContext } from 'react';

export const AccessContext = createContext<{
  hasTimeSeriesRwAccess?: boolean;
} | null>(null);
